<script setup>
import Layout from "../../layouts/main.vue";
import mushroom from "cem-primary-api";
import { onMounted, ref } from "vue";
import MethodService from "@/service/MethodService";
import toastr from "toastr";
import { useI18n } from "vue-i18n";
import SelectSocketGroup from "../../components/SelectSocketGroup.vue";
import { Filter } from "mushroomjs";
const { t } = useI18n();

const checkLogo = ref(false);
const idLogo = ref("");
const urlLogo = ref("");
const urlInput = ref("");
const errorUrl = ref(false);
const showDeleteInputUrl = ref(false);
const loadingBtn = ref(false);

const loadingBtnLanguage = ref(false);
const loadingBtnDefaultSocketGroupId = ref(false);
const loadingBtnSocketGroupIdForMultipleProbes = ref(false);
const idUrlConfig = ref("");
const idDefaultSocketGroupId = ref("");
const idSocketGroupIdForMultipleProbes = ref("");
const valueDefaultSocketGroupId = ref("");
const valueSocketGroupIdForMultipleProbes = ref("");
const valueMaxDynamicServiceHealth = ref(0);
const loadingBtnMaxDynamicServiceHealth = ref(false);
const idMaxDynamicServiceHealth = ref("");
const valueTimeUpdateStatusUsers = ref(0);
const loadingBtnTimeUpdateStatusUsers = ref(false);
const idTimeUpdateStatusUsers = ref("");
const valueTimeReload = ref(0);
const loadingBtnTimeReload = ref(false);
const idTimeReload = ref("");
const valueTimeAutoRefresh = ref(30);
const loadingBtnTimeAutoRefresh = ref(false);
const idTimeAutoRefresh = ref("");
const valueMaxPriorityServiceCount = ref(0);
const loadingBtnMaxPriorityServiceCount = ref(false);
const idMaxPriorityServiceCount = ref("");
const valueTimeRange = ref(null);
const loadingBtnTimeRange = ref(false);
const idTimeRange = ref("");
const valueMaxLoginFailCount = ref(5);
const loadingBtnMaxLoginFailCount = ref(false);
const idMaxLoginFailCount = ref("");
const valueLockLoginInMinutes = ref(5);
const loadingBtnLockLoginInMinutes = ref(false);
const idLockLoginInMinutes = ref("");
const valueLockWhenTooManyLoginFail = ref(false);
const loadingBtnLockWhenTooManyLoginFail = ref(false);
const idLockWhenTooManyLoginFail = ref("");
const valueWarnPasswordChangeAfterMinutes = ref("");
const loadingBtnWarnPasswordChange = ref(false);
const idWarnPasswordChangeAfterMinutes = ref("");
const valueChangePasswordAfterMinutes = ref("");
const loadingBtnChangePasswordAfter = ref(false);
const idChangePasswordAfterMinutes = ref("");
const flagLanguage = ref("");
const flagSrc = ref("");
const flagOptions = [
  {
    flag: require("@/assets/images/flags/vietnam.svg"),
    language: "vi",
    title: "Việt Nam",
  },
  {
    flag: require("@/assets/images/flags/us.svg"),
    language: "en",
    title: "English",
  },
];

const getUrlConfig = async () => {
  try {
    const response = await mushroom.system_config.listAsync({
      filters: "key=user_url",
    });
    if (response.result.length > 0) {
      urlInput.value = response.result[0].value;
      idUrlConfig.value = response.result[0].id;
    } else {
      const system_config_url = {
        key: "user_url",
        value: "https://",
        is_public: true,
        note: "user_url",
      };
      const newIdUrlConfig = await mushroom.system_config.createAsync(
        system_config_url,
      );
      idUrlConfig.value = newIdUrlConfig.result;
    }
  } catch (e) {
    console.error("Có lỗi: %o", e);
  }
};

const getLogo = async () => {
  try {
    const response = await mushroom.system_config.listAsync({
      filters: "key=logo",
    });
    if (response.result.length > 0) {
      checkLogo.value = true;
      idLogo.value = response.result[0].id;
      urlLogo.value = mushroom.$file.linkBuilder.thumb
        .id(response.result[0].value)
        .square(140)
        .build();
    }
  } catch (e) {
    console.error("Có lỗi: %o", e);
  }
};

const createFileLogo = async (value) => {
  if (checkLogo.value) {
    const system_config_object = {
      id: idLogo.value,
      value: value,
    };
    try {
      const response = await mushroom.system_config.partialUpdateAsync(
        system_config_object,
      );
      if (response.result == idLogo.value) {
        toastr.success(t("toastr_update_success"));
        getLogo();
      } else toastr.warning(t("toastr_not_change_warning"));
    } catch (error) {
      console.error("Có lỗi: %o", error);
    }
  } else {
    const system_config_object = {
      key: "logo",
      value: value,
      is_public: true,
      note: "Id của Logo",
    };
    try {
      const newId = await mushroom.system_config.createAsync(
        system_config_object,
      );
      if (newId.result) toastr.success(t("toastr_add_success"));
      getLogo();
    } catch (error) {
      console.error("Có lỗi: %o", error);
    }
  }
};

const uploadLogo = async () => {
  try {
    let nameImage = document.getElementById("uploadLogo").files[0]?.name;
    let typeImage = nameImage?.slice(nameImage.indexOf(".")).toLowerCase();

    if (typeImage) {
      if (
        typeImage !== ".jpg" &&
        typeImage !== ".png" &&
        typeImage !== ".jpeg"
      ) {
        toastr.warning(t("t_select_format_image"));
      } else {
        let res = await mushroom.$file.uploadAsync({
          file: document.getElementById("uploadLogo").files[0],
        });
        if (res.result) {
          createFileLogo(res.result);
        }
      }
    }
  } catch (e) {
    MethodService.showError(e.code);
  }
};

const deleteRecord = async () => {
  checkLogo.value = false;
  try {
    await mushroom.system_config.deleteAsync({
      id: idLogo.value,
    });
    document.getElementById("uploadLogo").value = "";
    toastr.success(t("toastr_delete_success"));
    getLogo();
  } catch (e) {
    console.error("Có lỗi: %o", e);
  }
};

const updateUrl = async () => {
  loadingBtn.value = true;
  errorUrl.value = false;
  let checkUrl = /^(https?:)?\/\//;
  const urlValue = (urlInput.value || "").trim();
  if (!urlValue.match(checkUrl)) {
    errorUrl.value = true;
    loadingBtn.value = false;
  } else {
    urlInput.value = urlValue.replace(/\s/g, "");
    try {
      const system_config_url = {
        id: idUrlConfig.value,
        key: "user_url",
        value: urlInput.value,
        is_public: true,
        note: urlInput.value,
      };
      const response = await mushroom.system_config.partialUpdateAsync(
        system_config_url,
      );
      if (response.result == system_config_url.id)
        toastr.success(t("toastr_update_success"));
    } catch (e) {
      MethodService.showError(e.code);
    } finally {
      loadingBtn.value = false;
    }
    errorUrl.value = false;
  }
  showDeleteInputUrl.value = false;
};

const deleteUrl = () => {
  urlInput.value = "";
  showDeleteInputUrl.value = false;
};

const clearErrorInput = () => {
  errorUrl.value = false;
  showDeleteInputUrl.value = true;
};

const changeSelectFlag = (flag) => {
  if (flag === "vi")
    flagSrc.value = require("@/assets/images/flags/vietnam.svg");
  if (flag === "en") flagSrc.value = require("@/assets/images/flags/us.svg");
};

const updateLanguage = async () => {
  loadingBtnLanguage.value = true;
  try {
    const resCheckHaveLanguage = await mushroom.system_config.listAsync({
      filters: ["key=language_default"],
    });
    if (resCheckHaveLanguage.result?.length === 0) {
      const newId = await mushroom.system_config.createAsync({
        key: "language_default",
        value: flagLanguage.value,
        is_public: true,
      });
      if (newId) {
        localStorage.setItem("language_default", flagLanguage.value);
        toastr.success(t("toastr_update_success"));
      }
    } else {
      const response = await mushroom.system_config.partialUpdateAsync({
        id: resCheckHaveLanguage.result[0].id,
        value: flagLanguage.value,
        is_public: true,
      });
      if (response.result == resCheckHaveLanguage.result[0].id) {
        localStorage.setItem("language_default", flagLanguage.value);
        toastr.success(t("toastr_update_success"));
      } else toastr.warning(t("toastr_not_change_warning"));
    }
  } catch (e) {
    console.error("Có lỗi: %o", e);
  } finally {
    loadingBtnLanguage.value = false;
  }
};

const getDefaultSocketGroupConfig = async () => {
  try {
    const response = await mushroom.system_config.listAsync({
      filters: "key=default_socket_group_id",
    });
    if (response.result.length > 0) {
      valueDefaultSocketGroupId.value = response.result[0].value;
      idDefaultSocketGroupId.value = response.result[0].id;
    } else {
      const system_config_socket = {
        key: "default_socket_group_id",
        value: "0",
        is_public: true,
        note: "Nhóm socket mặc định",
      };
      const newId = await mushroom.system_config.createAsync(
        system_config_socket,
      );
      valueDefaultSocketGroupId.value = undefined;
      idDefaultSocketGroupId.value = newId.result;
    }
  } catch (e) {
    console.error("Có lỗi: %o", e);
  }
};

const getSocketGroupForMultipleProbesConfig = async () => {
  try {
    const response = await mushroom.system_config.listAsync({
      filters: "key=socket_group_id_for_multiple_probes",
    });
    if (response.result.length > 0) {
      valueSocketGroupIdForMultipleProbes.value = response.result[0].value;
      idSocketGroupIdForMultipleProbes.value = response.result[0].id;
    } else {
      const system_config_socket = {
        key: "socket_group_id_for_multiple_probes",
        value: "0",
        is_public: true,
        note: "Nhóm socket cho multi-probe",
      };
      const newId = await mushroom.system_config.createAsync(
        system_config_socket,
      );
      valueSocketGroupIdForMultipleProbes.value = undefined;
      idSocketGroupIdForMultipleProbes.value = newId.result;
    }
  } catch (e) {
    console.error("Có lỗi: %o", e);
  }
};

const getMaxDynamicServiceHealthConfig = async () => {
  try {
    const response = await mushroom.system_config.listAsync({
      filters: "key=max_dynamic_service_health",
    });
    if (response.result.length > 0) {
      valueMaxDynamicServiceHealth.value =
        parseInt(response.result[0].value) || 0;
      idMaxDynamicServiceHealth.value = response.result[0].id;
    } else {
      const configObj = {
        key: "max_dynamic_service_health",
        value: "0",
        is_public: true,
        note: "Số lượng menu service-health tối đa",
      };
      const newId = await mushroom.system_config.createAsync(configObj);
      valueMaxDynamicServiceHealth.value = 0;
      idMaxDynamicServiceHealth.value = newId.result;
    }
  } catch (e) {
    console.error("Có lỗi: %o", e);
  }
};

const getTimeUpdateStatusUsersConfig = async () => {
  try {
    const response = await mushroom.system_config.listAsync({
      filters: Filter.eq("key", "online_threshold_time").build(),
    });
    if (response.result.length > 0) {
      valueTimeUpdateStatusUsers.value =
        parseInt(response.result[0].value) || 0;
      idTimeUpdateStatusUsers.value = response.result[0].id;
    } else {
      const configObj = {
        key: "online_threshold_time",
        value: "0",
        is_public: true,
        note: "Thời gian cập nhật trạng thái người dùng (giây)",
      };
      const newId = await mushroom.system_config.createAsync(configObj);
      valueTimeUpdateStatusUsers.value = 0;
      idTimeUpdateStatusUsers.value = newId.result;
    }
  } catch (e) {
    console.error("Có lỗi: %o", e);
  }
};

const updateTimeUpdateStatusUsers = async () => {
  loadingBtnTimeUpdateStatusUsers.value = true;
  try {
    const configObj = {
      id: idTimeUpdateStatusUsers.value,
      key: "online_threshold_time",
      value: valueTimeUpdateStatusUsers.value.toString(),
      is_public: true,
      note: "Thời gian cập nhật trạng thái người dùng (giây)",
    };
    const response = await mushroom.system_config.partialUpdateAsync(configObj);
    if (response.result == idTimeUpdateStatusUsers.value)
      toastr.success(t("toastr_update_success"));
  } catch (e) {
    MethodService.showError(e.code);
  } finally {
    loadingBtnTimeUpdateStatusUsers.value = false;
  }
};

const getTimeReloadConfig = async () => {
  try {
    const response = await mushroom.system_config.listAsync({
      filters: Filter.eq("key", "online_threshold_time_reload").build(),
    });
    if (response.result.length > 0) {
      valueTimeReload.value = parseInt(response.result[0].value) || 0;
      idTimeReload.value = response.result[0].id;
    } else {
      const configObj = {
        key: "online_threshold_time_reload",
        value: "0",
        is_public: true,
        note: "Thời gian cập nhật trạng thái (giây)",
      };
      const newId = await mushroom.system_config.createAsync(configObj);
      valueTimeReload.value = 0;
      idTimeReload.value = newId.result;
    }
  } catch (e) {
    console.error("Có lỗi: %o", e);
  }
};

const updateTimeReload = async () => {
  loadingBtnTimeReload.value = true;
  try {
    const configObj = {
      id: idTimeReload.value,
      key: "online_threshold_time_reload",
      value: valueTimeReload.value.toString(),
      is_public: true,
      note: "Thời gian cập nhật trạng thái (giây)",
    };
    const response = await mushroom.system_config.partialUpdateAsync(configObj);
    if (response.result == idTimeReload.value)
      toastr.success(t("toastr_update_success"));
  } catch (e) {
    MethodService.showError(e.code);
  } finally {
    loadingBtnTimeReload.value = false;
  }
};

const getTimeAutoRefreshConfig = async () => {
  try {
    const response = await mushroom.system_config.listAsync({
      filters: Filter.eq("key", "time_auto_refresh_data_probe").build(),
    });
    if (response.result.length > 0) {
      valueTimeAutoRefresh.value = parseInt(response.result[0].value) || 30;
      idTimeAutoRefresh.value = response.result[0].id;
    } else {
      const configObj = {
        key: "time_auto_refresh_data_probe",
        value: "30",
        is_public: true,
        note: "Thời gian auto-refresh dữ liệu bên probe (giây)",
      };
      const newId = await mushroom.system_config.createAsync(configObj);
      valueTimeAutoRefresh.value = 30;
      idTimeAutoRefresh.value = newId.result;
    }
  } catch (e) {
    console.error("Có lỗi: %o", e);
  }
};

const updateTimeAutoRefresh = async () => {
  loadingBtnTimeAutoRefresh.value = true;
  try {
    const configObj = {
      id: idTimeAutoRefresh.value,
      key: "time_auto_refresh_data_probe",
      value: valueTimeAutoRefresh.value.toString(),
      is_public: true,
      note: "Thời gian auto-refresh dữ liệu probe (giây)",
    };
    const response = await mushroom.system_config.partialUpdateAsync(configObj);
    if (response.result == idTimeAutoRefresh.value)
      toastr.success(t("toastr_update_success"));
  } catch (e) {
    MethodService.showError(e.code);
  } finally {
    loadingBtnTimeAutoRefresh.value = false;
  }
};

const getTimeRangeConfig = async () => {
  try {
    const response = await mushroom.system_config.listAsync({
      filters: Filter.eq("key", "time_range").build(),
    });
    if (response.result.length > 0) {
      const rawValue = response.result[0].value;
      valueTimeRange.value =
        rawValue === "" || rawValue == null ? null : parseInt(rawValue) || null;
      idTimeRange.value = response.result[0].id;
    } else {
      const configObj = {
        key: "time_range",
        value: "",
      };
      const newId = await mushroom.system_config.createAsync(configObj);
      valueTimeRange.value = null;
      idTimeRange.value = newId.result;
    }
  } catch (e) {
    console.error("Có lỗi: %o", e);
  }
};

const updateTimeRange = async () => {
  loadingBtnTimeRange.value = true;
  try {
    const configObj = {
      id: idTimeRange.value,
      key: "time_range",
      value:
        valueTimeRange.value != null ? valueTimeRange.value.toString() : "",
    };
    const response = await mushroom.system_config.partialUpdateAsync(configObj);
    if (response.result == idTimeRange.value)
      toastr.success(t("toastr_update_success"));
  } catch (e) {
    MethodService.showError(e.code);
  } finally {
    loadingBtnTimeRange.value = false;
  }
};

const setIdSocketGroupDefault = (id) => {
  console.log("id", id);
  valueDefaultSocketGroupId.value = id;
};
const setIdSocketGroupForMultipleProbes = (id) => {
  valueSocketGroupIdForMultipleProbes.value = id;
};

const updateSocketGroupConfig = async (code) => {
  code === "default_socket_group_id"
    ? (loadingBtnDefaultSocketGroupId.value = true)
    : (loadingBtnSocketGroupIdForMultipleProbes.value = true);
  try {
    const system_config_socket = {
      id:
        code === "default_socket_group_id"
          ? idDefaultSocketGroupId.value
          : idSocketGroupIdForMultipleProbes.value,
      key: code,
      value:
        code === "default_socket_group_id"
          ? valueDefaultSocketGroupId.value
          : valueSocketGroupIdForMultipleProbes.value,
      is_public: true,
      note:
        code === "default_socket_group_id"
          ? "Nhóm socket mặc định"
          : "Nhóm socket cho multi-probe",
    };
    console.log("system_config_socket", system_config_socket);

    const response = await mushroom.system_config.partialUpdateAsync(
      system_config_socket,
    );
    if (response.result == system_config_socket.id)
      toastr.success(t("toastr_update_success"));
  } catch (e) {
    MethodService.showError(e.code);
  } finally {
    loadingBtnDefaultSocketGroupId.value = false;
    loadingBtnSocketGroupIdForMultipleProbes.value = false;
  }
};

const updateMaxDynamicServiceHealth = async () => {
  loadingBtnMaxDynamicServiceHealth.value = true;
  try {
    const configObj = {
      id: idMaxDynamicServiceHealth.value,
      key: "max_dynamic_service_health",
      value: valueMaxDynamicServiceHealth.value.toString(),
      is_public: true,
      note: "Số lượng menu service-health tối đa",
    };
    const response = await mushroom.system_config.partialUpdateAsync(configObj);
    if (response.result == idMaxDynamicServiceHealth.value)
      toastr.success(t("toastr_update_success"));
  } catch (e) {
    MethodService.showError(e.code);
  } finally {
    loadingBtnMaxDynamicServiceHealth.value = false;
  }
};

const getMaxPriorityServiceCountConfig = async () => {
  try {
    const response = await mushroom.system_config.listAsync({
      filters: "key=max_priority_service_count",
    });
    if (response.result.length > 0) {
      valueMaxPriorityServiceCount.value =
        parseInt(response.result[0].value) || 0;
      idMaxPriorityServiceCount.value = response.result[0].id;
    } else {
      const configObj = {
        key: "max_priority_service_count",
        value: "0",
        is_public: true,
        note: "Số lượng tối đa dịch vụ ưu tiên",
      };
      const newId = await mushroom.system_config.createAsync(configObj);
      valueMaxPriorityServiceCount.value = 0;
      idMaxPriorityServiceCount.value = newId.result;
    }
  } catch (e) {
    console.error("Có lỗi: %o", e);
  }
};

const updateMaxPriorityServiceCount = async () => {
  loadingBtnMaxPriorityServiceCount.value = true;
  try {
    const configObj = {
      id: idMaxPriorityServiceCount.value,
      key: "max_priority_service_count",
      value: valueMaxPriorityServiceCount.value.toString(),
      is_public: true,
      note: "Số lượng tối đa dịch vụ ưu tiên",
    };
    const response = await mushroom.system_config.partialUpdateAsync(configObj);
    if (response.result == idMaxPriorityServiceCount.value)
      toastr.success(t("toastr_update_success"));
  } catch (e) {
    MethodService.showError(e.code);
  } finally {
    loadingBtnMaxPriorityServiceCount.value = false;
  }
};

// === Cấu hình chính sách đăng nhập ===
const getAuthPolicyConfigs = async () => {
  try {
    // auth.MaxLoginFailCount
    const resMaxFail = await mushroom.system_config.listAsync({
      filters: "key=auth.MaxLoginFailCount",
    });
    if (resMaxFail.result.length > 0) {
      valueMaxLoginFailCount.value = parseInt(resMaxFail.result[0].value) || 10;
      idMaxLoginFailCount.value = resMaxFail.result[0].id;
    } else {
      const configObj = {
        key: "auth.MaxLoginFailCount",
        value: "10",
        is_public: false,
        note: "Số lần login thất bại trước khi tài khoản bị tạm khóa",
      };
      const newId = await mushroom.system_config.createAsync(configObj);
      valueMaxLoginFailCount.value = 10;
      idMaxLoginFailCount.value = newId.result;
    }

    // auth.LockLoginInMinutes
    const resLockMinutes = await mushroom.system_config.listAsync({
      filters: "key=auth.LockLoginInMinutes",
    });
    if (resLockMinutes.result.length > 0) {
      valueLockLoginInMinutes.value =
        parseInt(resLockMinutes.result[0].value) || 10;
      idLockLoginInMinutes.value = resLockMinutes.result[0].id;
    } else {
      const configObj = {
        key: "auth.LockLoginInMinutes",
        value: "10",
        is_public: false,
        note: "Số phút tài khoản bị tạm khóa",
      };
      const newId = await mushroom.system_config.createAsync(configObj);
      valueLockLoginInMinutes.value = 10;
      idLockLoginInMinutes.value = newId.result;
    }

    // auth.LockWhenTooManyLoginFail
    const resLockEnabled = await mushroom.system_config.listAsync({
      filters: "key=auth.LockWhenTooManyLoginFail",
    });
    if (resLockEnabled.result.length > 0) {
      valueLockWhenTooManyLoginFail.value =
        resLockEnabled.result[0].value === "true";
      idLockWhenTooManyLoginFail.value = resLockEnabled.result[0].id;
    } else {
      const configObj = {
        key: "auth.LockWhenTooManyLoginFail",
        value: "false",
        is_public: false,
        note: "Có tạm khóa tài khoản nếu đăng nhập thất bại nhiều lần không",
      };
      const newId = await mushroom.system_config.createAsync(configObj);
      valueLockWhenTooManyLoginFail.value = false;
      idLockWhenTooManyLoginFail.value = newId.result;
    }

    // auth.WarnPasswordChangeAfterMinutes
    const resWarnPwdChange = await mushroom.system_config.listAsync({
      filters: "key=auth.WarnPasswordChangeAfterMinutes",
    });
    if (resWarnPwdChange.result.length > 0) {
      valueWarnPasswordChangeAfterMinutes.value =
        resWarnPwdChange.result[0].value;
      idWarnPasswordChangeAfterMinutes.value = resWarnPwdChange.result[0].id;
    } else {
      const configObj = {
        key: "auth.WarnPasswordChangeAfterMinutes",
        value: "",
      };
      const newId = await mushroom.system_config.createAsync(configObj);
      valueWarnPasswordChangeAfterMinutes.value = "";
      idWarnPasswordChangeAfterMinutes.value = newId.result;
    }

    // auth.ChangePasswordAfterMinutes
    const resChangePwdAfter = await mushroom.system_config.listAsync({
      filters: "key=auth.ChangePasswordAfterMinutes",
    });
    if (resChangePwdAfter.result.length > 0) {
      valueChangePasswordAfterMinutes.value = resChangePwdAfter.result[0].value;
      idChangePasswordAfterMinutes.value = resChangePwdAfter.result[0].id;
    } else {
      const configObj = {
        key: "auth.ChangePasswordAfterMinutes",
        value: "",
      };
      const newId = await mushroom.system_config.createAsync(configObj);
      valueChangePasswordAfterMinutes.value = "";
      idChangePasswordAfterMinutes.value = newId.result;
    }
  } catch (e) {
    console.error("Có lỗi: %o", e);
  }
};

const updateAuthPolicy = async (key) => {
  let id, value, loadingRef;

  switch (key) {
    case "auth.MaxLoginFailCount":
      loadingBtnMaxLoginFailCount.value = true;
      loadingRef = "loadingBtnMaxLoginFailCount";
      id = idMaxLoginFailCount.value;
      value = valueMaxLoginFailCount.value?.toString() || "";
      break;
    case "auth.LockLoginInMinutes":
      loadingBtnLockLoginInMinutes.value = true;
      loadingRef = "loadingBtnLockLoginInMinutes";
      id = idLockLoginInMinutes.value;
      value = valueLockLoginInMinutes.value?.toString() || "";
      break;
    case "auth.LockWhenTooManyLoginFail":
      loadingBtnLockWhenTooManyLoginFail.value = true;
      loadingRef = "loadingBtnLockWhenTooManyLoginFail";
      id = idLockWhenTooManyLoginFail.value;
      value = valueLockWhenTooManyLoginFail.value?.toString() || "";
      break;
    case "auth.WarnPasswordChangeAfterMinutes":
      loadingBtnWarnPasswordChange.value = true;
      loadingRef = "loadingBtnWarnPasswordChange";
      id = idWarnPasswordChangeAfterMinutes.value;
      value = valueWarnPasswordChangeAfterMinutes.value?.toString() || "";
      break;
    case "auth.ChangePasswordAfterMinutes":
      loadingBtnChangePasswordAfter.value = true;
      loadingRef = "loadingBtnChangePasswordAfter";
      id = idChangePasswordAfterMinutes.value;
      value = valueChangePasswordAfterMinutes.value?.toString() || "";
      break;
    default:
      return;
  }

  try {
    const configObj = {
      id: id,
      key: key,
      value: value,
    };
    const response = await mushroom.system_config.partialUpdateAsync(configObj);
    if (response.result == id) {
      toastr.success(t("toastr_update_success"));
      // Gọi API refresh auth policy sau khi update thành công
      try {
        await mushroom.user.refresh_auth_policyAsync({});
      } catch (err) {
        console.error("Refresh auth policy error: %o", err);
      }
    }
  } catch (e) {
    MethodService.showError(e.code);
  } finally {
    switch (loadingRef) {
      case "loadingBtnMaxLoginFailCount":
        loadingBtnMaxLoginFailCount.value = false;
        break;
      case "loadingBtnLockLoginInMinutes":
        loadingBtnLockLoginInMinutes.value = false;
        break;
      case "loadingBtnLockWhenTooManyLoginFail":
        loadingBtnLockWhenTooManyLoginFail.value = false;
        break;
      case "loadingBtnWarnPasswordChange":
        loadingBtnWarnPasswordChange.value = false;
        break;
      case "loadingBtnChangePasswordAfter":
        loadingBtnChangePasswordAfter.value = false;
        break;
    }
  }
};

const setLanguage = async () => {
  const res = await mushroom.system_config.listAsync({
    filters: ["key=language_default"],
  });
  if (res.result?.length > 0) {
    flagLanguage.value = res.result[0].value;
    changeSelectFlag(flagLanguage.value);
  } else flagSrc.value = require("@/assets/icon/none-icon-menu.svg");
};

onMounted(async () => {
  setLanguage();
  await getLogo();
  await getUrlConfig();

  await getDefaultSocketGroupConfig();
  await getSocketGroupForMultipleProbesConfig();
  await getMaxDynamicServiceHealthConfig();
  await getTimeUpdateStatusUsersConfig();
  await getTimeReloadConfig();
  await getTimeAutoRefreshConfig();
  await getMaxPriorityServiceCountConfig();
  await getTimeRangeConfig();
  await getAuthPolicyConfigs();
});
</script>

<template>
  <Layout>
    <div class="config-container">
      <div class="config-grid">
        <!-- Cấu hình ngôn ngữ -->
        <div class="config-card">
          <div class="card-header-modern">
            <h2 class="card-title">{{ $t("t_language_default") }}</h2>
          </div>
          <div class="card-content">
            <p class="card-description">{{ $t("t_select_language") }}</p>
            <div class="language-selector">
              <div class="flag-display">
                <img
                  v-if="flagSrc"
                  :src="flagSrc"
                  alt="flag"
                  class="flag-image"
                />
              </div>
              <el-select
                v-model="flagLanguage"
                @change="changeSelectFlag"
                :placeholder="$t('t_select_flag')"
                class="language-select"
              >
                <el-option
                  v-for="item in flagOptions"
                  :key="item.language"
                  :label="item.title"
                  :value="item.language"
                />
              </el-select>
              <button
                class="btn btn-secondary bg-gradient btn-border waves-effect waves-light"
                @click="updateLanguage"
                :loading="loadingBtnLanguage"
              >
                {{ $t("t-update") }}
              </button>
            </div>
          </div>
        </div>

        <!-- Cấu hình URL -->
        <div class="config-card">
          <div class="card-header-modern">
            <h2 class="card-title">{{ $t("t-config") }} URL</h2>
          </div>
          <div class="card-content">
            <p class="card-description">{{ $t("t_config_url_default") }}</p>
            <div class="url-input-group">
              <div class="input-wrapper">
                <el-input
                  v-model="urlInput"
                  :placeholder="$t('t-place-url')"
                  @focus="clearErrorInput"
                  @change="urlInput = urlInput.replace(/\s/g, '')"
                  class="url-input"
                  clearable
                />
                <button
                  v-show="showDeleteInputUrl"
                  @click="deleteUrl"
                  type="button"
                  class="btn-delete-url"
                  title="Xóa URL"
                >
                  <i class="ri-delete-bin-6-line"></i>
                </button>
              </div>
              <button
                class="btn btn-secondary bg-gradient btn-border waves-effect waves-light"
                @click="updateUrl"
                :loading="loadingBtn"
              >
                {{ $t("t-update") }}
              </button>
            </div>
            <Transition>
              <div v-show="errorUrl" class="error-message">
                <i class="ri-alert-line"></i> {{ $t("t_please_true_url") }}
              </div>
            </Transition>
          </div>
        </div>

        <!-- Cấu hình nhóm socket -->
        <div class="config-card">
          <div class="card-header-modern">
            <h2 class="card-title">{{ $t("t_socket_group_list_name") }}</h2>
          </div>
          <div class="card-content">
            <div class="card-content__item">
              <p class="card-description">
                {{ $t("t_default_socket_group_id") }}
              </p>
              <div class="socket-input-group">
                <SelectSocketGroup
                  :model-value="valueDefaultSocketGroupId"
                  @update:modelValue="setIdSocketGroupDefault"
                />
                <button
                  class="btn btn-secondary bg-gradient btn-border waves-effect waves-light"
                  @click="updateSocketGroupConfig('default_socket_group_id')"
                  :loading="loadingBtnDefaultSocketGroupId"
                >
                  {{ $t("t-update") }}
                </button>
              </div>
            </div>
            <div class="card-content__item">
              <p class="card-description">
                {{ $t("t_socket_group_id_for_multiple_probes") }}
              </p>
              <div class="socket-input-group">
                <SelectSocketGroup
                  :model-value="valueSocketGroupIdForMultipleProbes"
                  @update:modelValue="setIdSocketGroupForMultipleProbes"
                />
                <button
                  class="btn btn-secondary bg-gradient btn-border waves-effect waves-light"
                  @click="
                    updateSocketGroupConfig(
                      'socket_group_id_for_multiple_probes',
                    )
                  "
                  :loading="loadingBtnSocketGroupIdForMultipleProbes"
                >
                  {{ $t("t-update") }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- cấu hình logo -->
        <div class="config-card logo-card">
          <div class="card-header-modern">
            <h2 class="card-title">{{ $t("t-config") }} Logo</h2>
          </div>
          <div class="card-content">
            <p class="card-description">
              {{ $t("t_type") }}: .png, .jpg, .jpeg
            </p>
            <div class="logo-container">
              <div class="upload-area">
                <label for="uploadLogo" class="upload-label">
                  <div class="upload-content">
                    <i class="ri-upload-cloud-2-line"></i>
                    <h4>{{ $t("t-upload") }}</h4>
                  </div>
                </label>
                <input
                  type="file"
                  id="uploadLogo"
                  style="display: none"
                  @change="uploadLogo"
                />
              </div>

              <div class="preview-area">
                <div class="preview-box">
                  <img
                    v-if="checkLogo"
                    :src="urlLogo"
                    alt="Logo"
                    class="logo-preview"
                  />
                  <div v-else class="logo-placeholder">
                    <span>CEM</span>
                  </div>
                </div>
                <el-button
                  v-if="checkLogo"
                  type="danger"
                  @click="deleteRecord"
                  class="btn-delete-logo"
                >
                  <i class="ri-delete-bin-6-line"></i> {{ $t("t-delete") }}
                </el-button>
              </div>
            </div>
          </div>
        </div>

        <!-- Cấu hình chính sách đăng nhập -->
        <div class="config-card config-card--full-width">
          <div class="card-header-modern">
            <h2 class="card-title">
              {{ $t("t_config_auth_policy") }}
            </h2>
          </div>
          <div class="card-content">
            <div class="config-row-3cards-inner">
              <div class="config-card-inner">
                <p class="card-description">
                  {{ $t("t_config_max_login_fail_count_desc") }}
                </p>
                <div class="max-service-health-group">
                  <el-input-number
                    v-model="valueMaxLoginFailCount"
                    :min="1"
                    :precision="0"
                    :step="1"
                    class="service-health-number"
                  />
                  <button
                    class="btn btn-secondary bg-gradient btn-border waves-effect waves-light"
                    @click="updateAuthPolicy('auth.MaxLoginFailCount')"
                    :loading="loadingBtnMaxLoginFailCount"
                  >
                    {{ $t("t-update") }}
                  </button>
                </div>
              </div>

              <div class="config-card-inner">
                <p class="card-description">
                  {{ $t("t_config_lock_login_in_minutes_desc") }}
                </p>
                <div class="max-service-health-group">
                  <el-input-number
                    v-model="valueLockLoginInMinutes"
                    :min="1"
                    :precision="0"
                    :step="1"
                    class="service-health-number"
                  />
                  <button
                    class="btn btn-secondary bg-gradient btn-border waves-effect waves-light"
                    @click="updateAuthPolicy('auth.LockLoginInMinutes')"
                    :loading="loadingBtnLockLoginInMinutes"
                  >
                    {{ $t("t-update") }}
                  </button>
                </div>
              </div>

              <div class="config-card-inner">
                <p class="card-description">
                  {{ $t("t_config_lock_when_too_many_fail_desc") }}
                </p>
                <div class="max-service-health-group">
                  <el-switch
                    v-model="valueLockWhenTooManyLoginFail"
                    class="service-health-number"
                    :active-text="$t('t_lock_account_active')"
                  />
                  <button
                    class="btn btn-secondary bg-gradient btn-border waves-effect waves-light"
                    @click="updateAuthPolicy('auth.LockWhenTooManyLoginFail')"
                    :loading="loadingBtnLockWhenTooManyLoginFail"
                  >
                    {{ $t("t-update") }}
                  </button>
                </div>
              </div>
            </div>
            <div class="config-row-3cards-inner mt-3">
              <div class="config-card-inner">
                <p class="card-description">
                  {{ $t("t_config_warn_password_change_desc") }}
                </p>
                <div class="max-service-health-group">
                  <el-input
                    v-model.number="valueWarnPasswordChangeAfterMinutes"
                    type="number"
                    :placeholder="$t('t_config_password_change_placeholder')"
                    class="service-health-number"
                    @input="
                      (val) => {
                        valueWarnPasswordChangeAfterMinutes =
                          val === '' || val == null ? null : Number(val);
                      }
                    "
                  />
                  <button
                    class="btn btn-secondary bg-gradient btn-border waves-effect waves-light"
                    @click="
                      updateAuthPolicy('auth.WarnPasswordChangeAfterMinutes')
                    "
                    :loading="loadingBtnWarnPasswordChange"
                  >
                    {{ $t("t-update") }}
                  </button>
                </div>
              </div>

              <div class="config-card-inner">
                <p class="card-description">
                  {{ $t("t_config_change_password_after_desc") }}
                </p>
                <div class="max-service-health-group">
                  <el-input
                    v-model.number="valueChangePasswordAfterMinutes"
                    type="number"
                    :placeholder="$t('t_config_password_change_placeholder')"
                    class="service-health-number"
                    @input="
                      (val) => {
                        valueChangePasswordAfterMinutes =
                          val === '' || val == null ? null : Number(val);
                      }
                    "
                  />
                  <button
                    class="btn btn-secondary bg-gradient btn-border waves-effect waves-light"
                    @click="updateAuthPolicy('auth.ChangePasswordAfterMinutes')"
                    :loading="loadingBtnChangePasswordAfter"
                  >
                    {{ $t("t-update") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Cấu hình giá trị time_range -->
        <div class="config-card">
          <div class="card-header-modern">
            <h2 class="card-title">{{ $t("t_config_time_range") }}</h2>
          </div>
          <div class="card-content">
            <p class="card-description">{{ $t("t_config_time_range_desc") }}</p>
            <div class="max-service-health-group">
              <el-input
                v-model.number="valueTimeRange"
                type="number"
                :min="0"
                class="service-health-number"
                @input="
                  (val) => {
                    valueTimeRange =
                      val === '' || val == null ? null : Number(val);
                  }
                "
              />
              <button
                class="btn btn-secondary bg-gradient btn-border waves-effect waves-light"
                @click="updateTimeRange"
                :loading="loadingBtnTimeRange"
              >
                {{ $t("t-update") }}
              </button>
            </div>
          </div>
        </div>

        <!-- Cấu hình số lượng menu service-health / auto-refresh / dịch vụ ưu tiên -->
        <div class="config-card">
          <div class="card-header-modern">
            <h2 class="card-title">
              {{ $t("t_config_max_service_health") }}
            </h2>
          </div>
          <div class="card-content">
            <p class="card-description">
              {{ $t("t_max_service_health_desc") }}
            </p>
            <div class="max-service-health-group">
              <el-input-number
                v-model="valueMaxDynamicServiceHealth"
                :min="1"
                :precision="0"
                :step="1"
                class="service-health-number"
              />
              <button
                class="btn btn-secondary bg-gradient btn-border waves-effect waves-light"
                @click="updateMaxDynamicServiceHealth"
                :loading="loadingBtnMaxDynamicServiceHealth"
              >
                {{ $t("t-update") }}
              </button>
            </div>
          </div>
        </div>

        <div class="config-card">
          <div class="card-header-modern">
            <h2 class="card-title">
              {{ $t("t_config_time_auto_refresh") }}
            </h2>
          </div>
          <div class="card-content">
            <p class="card-description">
              {{ $t("t_config_time_auto_refresh_label") }}
            </p>
            <div class="max-service-health-group">
              <el-input-number
                v-model="valueTimeAutoRefresh"
                :min="1"
                :precision="0"
                :step="1"
                class="service-health-number"
              />
              <button
                class="btn btn-secondary bg-gradient btn-border waves-effect waves-light"
                @click="updateTimeAutoRefresh"
                :loading="loadingBtnTimeAutoRefresh"
              >
                {{ $t("t-update") }}
              </button>
            </div>
          </div>
        </div>

        <div class="config-card">
          <div class="card-header-modern">
            <h2 class="card-title">
              {{ $t("t_config_max_priority_service") }}
            </h2>
          </div>
          <div class="card-content">
            <p class="card-description">
              {{ $t("t_max_priority_service_desc") }}
            </p>
            <div class="max-service-health-group">
              <el-input-number
                v-model="valueMaxPriorityServiceCount"
                :min="0"
                :precision="0"
                :step="1"
                class="service-health-number"
              />
              <button
                class="btn btn-secondary bg-gradient btn-border waves-effect waves-light"
                @click="updateMaxPriorityServiceCount"
                :loading="loadingBtnMaxPriorityServiceCount"
              >
                {{ $t("t-update") }}
              </button>
            </div>
          </div>
        </div>

        <!-- Cấu hình thời gian người dùng hoạt động gần nhất -->
        <div class="config-card config-card--full-width">
          <div class="card-header-modern">
            <h2 class="card-title">
              {{ $t("t_config_online_threshold_time") }}
            </h2>
          </div>
          <div class="card-content">
            <div class="config-row-3cards-inner">
              <div class="config-card-inner">
                <p class="card-description">
                  {{ $t("t_config_online_threshold_time_label") }}
                </p>
                <div class="max-service-health-group">
                  <el-input-number
                    v-model="valueTimeUpdateStatusUsers"
                    :min="1"
                    :precision="0"
                    :step="1"
                    class="service-health-number"
                  />
                  <button
                    class="btn btn-secondary bg-gradient btn-border waves-effect waves-light"
                    @click="updateTimeUpdateStatusUsers"
                    :loading="loadingBtnTimeUpdateStatusUsers"
                  >
                    {{ $t("t-update") }}
                  </button>
                </div>
              </div>

              <div class="config-card-inner">
                <p class="card-description">
                  {{ $t("t_config_online_threshold_time_reload_label") }}
                </p>
                <div class="max-service-health-group">
                  <el-input-number
                    v-model="valueTimeReload"
                    :min="1"
                    :precision="0"
                    :step="1"
                    class="service-health-number"
                  />
                  <button
                    class="btn btn-secondary bg-gradient btn-border waves-effect waves-light"
                    @click="updateTimeReload"
                    :loading="loadingBtnTimeReload"
                  >
                    {{ $t("t-update") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" scoped src="./cau-hinh-chung.scss"></style>
